import React, { Component } from 'react'
import { TxBottom } from '../../../../components'

class AddressTransactions extends Component {
    render() {
        return <TxBottom {...this.props} />
    }
}

export default AddressTransactions
